__webpack_require__.p = "https://admision.tec.mx/a/sedes/";